import * as React from "react";
import { useIsFetching, useIsMutating, useQuery } from "@tanstack/react-query";
import { PortalManagement } from "./PortalManagement";
import { AccountContextProvider } from "./AccountContext";
import { storefrontApi } from "@/services/storefront";
import { RechargeAddress, RechargeItemRaw } from "./types";

type SubscriptionPortalRootProps = {
  rawSubscriptions: RechargeItemRaw[];
  addresses: RechargeAddress[];
};

export const SubscriptionPortalRoot = ({
  rawSubscriptions,
  addresses,
}: SubscriptionPortalRootProps) => {
  const rechargeSubQuery = useQuery({
    queryKey: ["rechargeSubscriptions"],
    initialData: rawSubscriptions,
    queryFn: () => Promise.resolve(rawSubscriptions),
    staleTime: Infinity,
  });
  const rechargeAddressQuery = useQuery({
    queryKey: ["rechargeAddresses"],
    initialData: addresses,
    queryFn: () => Promise.resolve(addresses),
    staleTime: Infinity,
  });
  const catalog = storefrontApi.useCollection("portal-sorted-collection");

  if (!catalog.data || !rechargeAddressQuery.data || !rechargeSubQuery.data) {
    return <div>Loading...</div>;
  }

  if (catalog.error || rechargeAddressQuery.error || rechargeSubQuery.error) {
    return <div>There was an error loading your data.</div>;
  }

  return (
    <AccountContextProvider
      rechargeAddresses={rechargeAddressQuery.data}
      subscriptionsAndOnetimes={rechargeSubQuery.data}
      catalog={catalog.data}
    >
      <PortalManagement />
    </AccountContextProvider>
  );
};

export function useRequestInProgress() {
  const isMutating = useIsMutating();
  const isFetching = useIsFetching();
  return isMutating + isFetching;
}
